import windowManipulationService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/windowManipulationService';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';

const isClientSideRendering = windowManipulationService.isBrowserEnvironment();

export default class LocalStorageManipulationService {
    static setLastClickedLoginOrRegister(value) {
        if (!isClientSideRendering || IS_FRAME_SERVICE) return;
        try {
            localStorage.setItem('lastClickedLoginOrRegister', value);
        } catch (error) {
            reportError(new Error('Greška prilikom postavljanja "lastClickedLoginOrRegister" u servisu "setLastClickedLoginOrRegister/LocalStorageManipulationService":', error));
        }
    }

    static setTrackingItem(item) {
        if (!isClientSideRendering || IS_FRAME_SERVICE) return;
        try {
            localStorage.setItem('trackingItem', JSON.stringify(item));
        } catch (error) {
            reportError(
                new Error('Greška prilikom postavljanja "trackingItem" u servisu "setTrackingItem/LocalStorageManipulationService":', error),
            );
        }
    }

    static getTrackingItem() {
        if (!isClientSideRendering || IS_FRAME_SERVICE) return null;
        try {
            const item = localStorage.getItem('trackingItem');
            return item ? JSON.parse(item) : null;
        } catch (error) {
            reportError(
                new Error('Greška prilikom čitanja "trackingItem" u servisu "getTrackingItem/LocalStorageManipulationService":', error),
            );
            return null;
        }
    }

    static removeTrackingItem() {
        if (!isClientSideRendering || IS_FRAME_SERVICE) return;
        try {
            localStorage.removeItem('trackingItem');
        } catch (error) {
            reportError(
                new Error('Greška prilikom brisanja "trackingItem" u servisu "removeTrackingItem/LocalStorageManipulationService":', error),
            );
        }
    }
}
